module.exports = __webpack_public_path__ + "img/security.c33a2548.svg";